import { render, staticRenderFns } from "./TemplateSort.vue?vue&type=template&id=0e6d0f7c&scoped=true&"
import script from "./TemplateSort.vue?vue&type=script&lang=js&"
export * from "./TemplateSort.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSort.vue?vue&type=style&index=0&id=0e6d0f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6d0f7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
